import Tag, { TagId } from '@/shared/models/Tag';
import { UserId } from '@/shared/models/User';
import { isPresent } from '@/shared/utils/typescript';
import InvoicingPeriod from '../constants/InvoicingPeriod';
import AbstractTask from './AbstractTask';

export default class InvoicingTask extends AbstractTask {
  assignedUserId: UserId | null = null;
  amount!: number;
  period!: InvoicingPeriod;
  tags: Array<Tag> = [];

  isAssignedToAny(userIds: Array<UserId>): boolean {
    return isPresent(this.assignedUserId) && userIds.includes(this.assignedUserId);
  }

  matchesPeriod(period: InvoicingPeriod | null): boolean {
    return !period || this.period === period;
  }

  matchesTags(tagIds: Array<TagId>): boolean {
    return tagIds.length === 0 || this.tags.some(t => t.id !== null && tagIds.includes(t.id));
  }
}
